import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import MatriculasView from './MatriculasView';
import * as ROUTES from '../../../router/Routes';

const MatriculasModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.matriculas}
      routes={[ROUTES.controlEstudios]}
    >
      <MatriculasView />
    </ContainerTemplate>
  );
};

export default MatriculasModule;
